module.exports = __webpack_public_path__ + "img/pakiet-roj.2d43c496.jpg";